import * as React from "react";
import moment from 'moment';
// Amplify UI
import { Badge, Text } from "@aws-amplify/ui-react";
import IconStreamingNow from './../../../assets/icon-streaming-now.svg';
import IconStreamingToday from './../../../assets/icon-streaming-today.svg';
import IconStreamingUpcoming from './../../../assets/icon-streaming-upcoming.svg';
import IconStreamingPast from './../../../assets/icon-streaming-past.svg';
import SponsorLogoDefault from "./../../../assets/default.png";
import * as Styled from "./SmallCard.styled";
import { ILiveStream } from "../../../types";
import { CalendarPlus, PlayCircle } from "react-bootstrap-icons";

export const SmallCard: React.FC<{
    event: ILiveStream;
    hasEligiblePlan: boolean;
    onWatchClick: (event: ILiveStream) => void;
    cardClick: (event: ILiveStream) => void;
    isSelected?: boolean;
    isSignedIn?: boolean;
    bodyWidth?: string;
}> = ({ event, onWatchClick, isSelected, cardClick, bodyWidth }) => {

    // const LABEL_WATCH_NOW = 'Watch Now';
    // const LABEL_GET_ACCESS = 'Get Access';
    // const LABEL_PURCHASE_PLAN = "Purchase Plan";
    // const LABEL_STREAMING_SOON = 'Streaming Soon';
    // const LABEL_UPCOMING = 'Upcoming';

    const isNow = React.useCallback((dateStart: string, dateEnd: string) => {
        const now = moment(new Date(), moment.ISO_8601);
        const eventDateStart = moment(dateStart, moment.ISO_8601);
        const eventDateEnd = dateEnd ? moment(dateEnd, moment.ISO_8601) : moment(eventDateStart).add({ hours: 1 });
        return moment(now).isBetween(eventDateStart, eventDateEnd);
    }, []);

    const isToday = React.useCallback((date: string) => {
        const today = moment(new Date(), moment.ISO_8601);
        const eventDate = moment(date, moment.ISO_8601);
        return moment(eventDate).isSame(today, 'day');
    }, []);

    const isFuture = React.useCallback((date: string) => {
        const today = moment(new Date(), moment.ISO_8601);
        const eventDate = moment(date, moment.ISO_8601);
        return moment(eventDate).isAfter(today, 'day');
    }, []);

    const isPast = React.useCallback((date: string) => {
        const today = moment(new Date(), moment.ISO_8601);
        const eventDate = moment(date, moment.ISO_8601);
        return moment(eventDate).isBefore(today, 'day');
    }, []);

    const isEventNow = React.useMemo(() => {
        return isNow(event.eventStartDate, event.eventEndDate) || event.streamingUrl;
    }, [event, isNow]);

    const isEventToday = React.useMemo(() => {
        return isToday(event.date);
    }, [event.date, isToday]);

    const isEventFuture = React.useMemo(() => {
        return isFuture(event.date);
    }, [event.date, isFuture]);

    const isEventPast = React.useMemo(() => {
        return isPast(event.date);
    }, [event.date, isPast]);

    const cheapPackageName = React.useMemo(() => {
        let _arr = event.planDetails;
        _arr.sort((a, b) => a.amount - b.amount);
        return _arr[0]?.name || '';
    }, [event.planDetails]);

    // const eventStatus = React.useMemo(() => {
    //     let _status;

    //     if (event.isPrivate) {

    //         if (isSignedIn) {

    //             if (hasEligiblePlan) {

    //                 if (isEventNow) {
    //                     _status = LABEL_WATCH_NOW;
    //                 } else if (isEventToday) {
    //                     _status = LABEL_STREAMING_SOON;
    //                 } else if (isEventFuture) {
    //                     _status = LABEL_UPCOMING;
    //                 } else {
    //                     _status = LABEL_WATCH_NOW;
    //                 }

    //             } else {
    //                 _status = LABEL_PURCHASE_PLAN;
    //             }

    //         } else {
    //             _status = LABEL_GET_ACCESS;
    //         }

    //     } else {

    //         if (isEventNow) {
    //             _status = LABEL_WATCH_NOW;
    //         } else if (isEventToday) {
    //             _status = LABEL_STREAMING_SOON;
    //         } else if (isEventFuture) {
    //             _status = LABEL_UPCOMING;
    //         } else {
    //             _status = LABEL_WATCH_NOW;
    //         }

    //     }

    //     return _status;
    // }, [
    //     event,
    //     isSignedIn,
    //     hasEligiblePlan,
    //     isEventNow,
    //     isEventToday,
    //     isEventFuture
    // ]);

    /**
   * @function handlePosterOver
   * @description Poster mouseenter event handler.
   * @param {Object} evt 
   */
    // function handlePosterOver(evt: React.MouseEvent<any>): void {
    //     evt.currentTarget.focus();
    //     let targetParent = evt.currentTarget.closest('.media-card');
    //     let targetPoster = targetParent.querySelector('.media-poster');
    //     let targetAncillary = targetParent.querySelector('.media-ancillary');
    //     targetParent.classList.add('hover-intent');
    //     targetPoster.classList.add('hover-intent');
    //     targetAncillary.classList.add('hover-intent');
    // }


    /**
     * @function handlePosterOut
     * @description Poster mouseleave event handler.
     * @param {Object} evt 
     */
    // function handlePosterOut(evt: React.MouseEvent<any>): void {
    //     let targetParent = evt.currentTarget.closest('.media-card');
    //     let targetPoster = targetParent.querySelector('.media-poster');
    //     let targetAncillary = targetParent.querySelector('.media-ancillary');
    //     targetParent.classList.remove('hover-intent');
    //     targetPoster.classList.remove('hover-intent');
    //     targetAncillary.classList.remove('hover-intent');
    // }

    /**
     * @function handlePosterFocus
     * @description Poster focus event handler.
     * @param {Object} evt 
     */
    // function handlePosterFocus(evt: React.FocusEvent<any>): void {
    //     let targetParent = evt.currentTarget.closest('.media-card');
    //     let targetPoster = targetParent.querySelector('.media-poster');
    //     let targetAncillary = targetParent.querySelector('.media-ancillary');
    //     targetParent.classList.add('hover-intent');
    //     targetPoster.classList.add('hover-intent');
    //     targetAncillary.classList.add('hover-intent');
    // }

    /**
     * @function handlePosterBlur
     * @description Poster blur event handler.
     * @param {Object} evt 
     */
    // function handlePosterBlur(evt: React.FocusEvent<any>) {
    //     if (!evt.currentTarget.parentNode.parentNode.contains(evt.relatedTarget)) {
    //         let targetParent = evt.currentTarget.closest('.media-card');
    //         let targetPoster = targetParent.querySelector('.media-poster');
    //         let targetAncillary = targetParent.querySelector('.media-ancillary');
    //         targetParent.classList.remove('hover-intent');
    //         targetPoster.classList.remove('hover-intent');
    //         targetAncillary.classList.remove('hover-intent');
    //     }
    // }

    return (
        <Styled.MediaCard
            className={`${isEventNow ? "is-now"
                : isEventToday ? "is-today"
                    : isEventFuture ? "is-upcoming"
                        : isEventPast ? "is-past"
                            : ""} ${event.isPrivate ? "is-private" : ""} media-card`}
        >
            <Styled.MediaCardWrapper className="media-card--wrapper" isSelected={isSelected}>

                <Styled.EventCardBodyWrapper onClick={() => cardClick(event)} width={bodyWidth}>

                    <Styled.TitleWrapper>
                        <div>
                            <Styled.Title title={event.title}>{event.title}</Styled.Title>
                            <div className={`${isEventNow ? "is-now"
                                : isEventToday ? "is-today"
                                    : isEventFuture ? "is-upcoming"
                                        : isEventPast ? "is-past"
                                            : ""} ${event.isPrivate ? "is-private" : ""} event-happens-badge`}>
                                {isEventNow ? (<img src={IconStreamingNow} height="26" style={{ maxHeight: '26px' }} alt="Now" />)
                                    : isEventToday ? (<img src={IconStreamingToday} height="22" style={{ maxHeight: '22px' }} alt="Today" />)
                                        : isEventFuture ? (<img src={IconStreamingUpcoming} height="22" style={{ maxHeight: '22px' }} alt="Upcoming" />)
                                            : isEventPast ? (<img src={IconStreamingPast} height="22" style={{ maxHeight: '22px' }} alt="Past" />)
                                                : ""}
                            </div>
                        </div>
                        <Styled.Logo className="ms-auto" src={event.sponsorLogo ? event.sponsorLogo : SponsorLogoDefault} />
                    </Styled.TitleWrapper>

                    <Text
                        variation="primary"
                        as="p"
                        lineHeight="1"
                        fontWeight={400}
                        fontSize="0.75em"
                        fontStyle="normal"
                    >
                        {event.isPrivate && (
                            <span style={{ lineHeight: '1.25', cursor: 'context-menu' }}>
                                Available with <strong style={{ fontWeight: '700' }}>{cheapPackageName}</strong>.<br />
                            </span>
                        )}
                    </Text>

                </Styled.EventCardBodyWrapper>

                <Styled.Divider
                    className={`${isEventNow ? "is-now"
                        : isEventToday ? "is-today"
                            : isEventFuture ? "is-upcoming"
                                : isEventPast ? "is-past"
                                    : ""} ${event.isPrivate ? "is-private" : ""} event-divider`}></Styled.Divider>

                <Styled.EventCardDetailWrapper
                    className={`${isEventNow ? "is-now"
                        : isEventToday ? "is-today"
                            : isEventFuture ? "is-upcoming"
                                : isEventPast ? "is-past"
                                    : ""} ${event.isPrivate ? "is-private" : ""} event-detail`}>

                    <Styled.EventDateWrapper
                        className={`${isEventNow ? "is-now"
                            : isEventToday ? "is-today"
                                : isEventFuture ? "is-upcoming"
                                    : isEventPast ? "is-past"
                                        : ""} ${event.isPrivate ? "is-private" : ""} event-date`}
                        style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <span data-date={event.date} style={{ lineHeight: '1.125' }}>
                            {moment(new Date(event.date)).format('MMM Do, YYYY')}<br />
                            {moment(new Date(event.date)).format('h:mmA')}
                        </span>
                    </Styled.EventDateWrapper>

                    <Styled.EventActionWrapper>

                        <Badge onClick={() => onWatchClick(event)}
                            className={`${isEventNow ? "is-now"
                                : isEventToday ? "is-today"
                                    : isEventFuture ? "is-upcoming"
                                        : isEventPast ? "is-past"
                                            : ""} ${event.isPrivate ? "is-private" : ""} event-button`}
                            borderRadius="3px"
                            style={{ cursor: "pointer" }}>
                            <PlayCircle size={16} />
                        </Badge>

                        <Badge onClick={() => onWatchClick(event)}
                            className={`${isEventNow ? "is-now"
                                : isEventToday ? "is-today"
                                    : isEventFuture ? "is-upcoming"
                                        : isEventPast ? "is-past"
                                            : ""} ${event.isPrivate ? "is-private" : ""} event-button`}
                            borderRadius="3px"
                            style={{ cursor: "pointer" }}>
                            <CalendarPlus size={16} />
                        </Badge>
                    </Styled.EventActionWrapper>

                </Styled.EventCardDetailWrapper>
            </Styled.MediaCardWrapper>
        </Styled.MediaCard>
    );
};
